export interface HotTopic {
  id: number;
  rank: number;
  title: string;
  tag: string;
  heat: number;
  delta: string;
  trend: "up" | "down" | "new";
  summary: string;
}

export interface FeedItem {
  id: number;
  time: string;
  phase: string;
  tag: string;
  title: string;
  digest: string;
  views: string;
}

export interface Category {
  id: number;
  icon: string;
  name: string;
  desc: string;
  count: string;
}

export interface NewsCard {
  id: number;
  image: string;
  tag: string;
  title: string;
  excerpt: string;
  time: string;
  hot: number;
}

export interface Faq {
  q: string;
  a: string;
}

export const hotTopics: HotTopic[] = [
  { id: 1, rank: 1, title: "新综艺阵容官宣,国民级搭配引发全网蹲更新", tag: "综艺现场", heat: 98, delta: "2.3万", trend: "up", summary: "嘉宾名单一经公布立刻冲上热搜,吃瓜群众纷纷蹲守首期正片。午间与睡前两轮速览均高亮。", },
  { id: 2, rank: 2, title: "顶流剧组杀青合照流出,片场互动细节被扒", tag: "剧集一线", heat: 94, delta: "1.8万", trend: "up", summary: "一张花絮照让网友逐帧分析,连道具摆位都能聊出三个版本,今日打卡人数持续走高。", },
  { id: 3, rank: 3, title: "年度音乐盛典入围名单公布,黑马新人登榜", tag: "音乐风云", heat: 91, delta: "1.6万", trend: "new", summary: "多家厂牌下场造势,榜单前列竞争激烈,蹲更新用户已开启定时刷新蹲守结果。", },
  { id: 4, rank: 4, title: "电影节红毯名场面盘点,造型师纷纷出来认领", tag: "影坛新事", heat: 87, delta: "1.2万", trend: "up", summary: "三套造型被反复截取,时尚博主连夜出解析,睡前必看清单里必须有它。", },
  { id: 5, rank: 5, title: "老牌艺人与新生代同台,代际碰撞擦出火花", tag: "明星动态", heat: 82, delta: "8600", trend: "down", summary: "访谈名场面被做成表情包疯传,通勤速览用户反馈笑到坐过站。", },
  { id: 6, rank: 6, title: "热播剧二创大赛开启,网友脑洞根本停不下来", tag: "圈内幕后", heat: 78, delta: "7200", trend: "up", summary: "官方下场征集同人,评论区变大型团建现场,今日新增打卡人数暴涨。", },
];

export const feedItems: FeedItem[] = [
  { id: 1, time: "08:30", phase: "通勤速览", tag: "早安瓜报", title: "昨夜十大热点复盘,一键补完全部瓜", digest: "通勤路上五分钟看完隔夜动态,错过也不怕掉队。", views: "4.2万" },
  { id: 2, time: "11:00", phase: "上午蹲更", tag: "首发快讯", title: "某剧组官微发布新海报,文案暗藏彩蛋", digest: "放大十倍找线索是瓜友基本功,评论区已解锁隐藏剧情。", views: "3.6万" },
  { id: 3, time: "13:30", phase: "午间刷新", tag: "实时热榜", title: "午间热度榜更新,这几位排名飙升最快", digest: "午休十分钟刷新一下,掌握上午圈内风向。", views: "2.9万" },
  { id: 4, time: "16:00", phase: "午后追更", tag: "深度追踪", title: "热播综艺幕后花絮释出,细节控狂喜", digest: "节目组放出的未播片段,让蹲更新的人直呼值得。", views: "3.1万" },
  { id: 5, time: "20:00", phase: "黄金时段", tag: "焦点热瓜", title: "晚高峰话题汇总,三条瓜同时登顶", digest: "黄金时段集中爆点,睡前必看安排上,一次看完别留到明天。", views: "5.8万" },
  { id: 6, time: "22:30", phase: "睡前必看", tag: "晚安瓜报", title: "今日瓜报收官,明日看点抢先预告", digest: "看完这份睡前清单就可以安心入睡,明日更新已预约蹲守。", views: "6.3万" },
];

export const categories: Category[] = [
  { id: 1, icon: "ri-mic-line", name: "综艺现场", desc: "选秀、真人秀、音综台前幕后", count: "今日 12 条" },
  { id: 2, icon: "ri-film-line", name: "剧集一线", desc: "新剧开机、定档、花絮与口碑", count: "今日 18 条" },
  { id: 3, icon: "ri-music-2-line", name: "音乐风云", desc: "榜单、巡演、专辑与颁奖礼", count: "今日 9 条" },
  { id: 4, icon: "ri-camera-line", name: "影坛新事", desc: "电影节、红毯与幕后创作", count: "今日 7 条" },
  { id: 5, icon: "ri-user-heart-line", name: "明星动态", desc: "行程、营业与同框名场面", count: "今日 15 条" },
  { id: 6, icon: "ri-vip-crown-line", name: "圈内幕后", desc: "行业观察与制作内幕冷知识", count: "今日 6 条" },
];

export const newsCards: NewsCard[] = [
  { id: 1, image: "https://readdy.ai/api/search-image?query=Warm%20film%20set%20behind%20the%20scenes%20with%20director%20chair%20clapperboard%20and%20stage%20lights%2C%20soft%20coral%20and%20mint%20toned%20editorial%20illustration%2C%20modern%20flat%20style%2C%20playful%20watermelon%20accents&width=640&height=440&seq=news-drama-set&orientation=landscape", tag: "剧集一线", title: "热播剧开机两周,男女主角同框路透流出", excerpt: "路透照一经曝光立即刷屏,网友开始蹲守正片播出日期。", time: "今天 10:20", hot: 87 },
  { id: 2, image: "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20colorful%20spotlights%20and%20crowd%20silhouettes%20cheering%2C%20warm%20amber%20and%20coral%20tones%2C%20modern%20flat%20editorial%20illustration&width=640&height=440&seq=news-concert&orientation=landscape", tag: "音乐风云", title: "年度巡演官宣四站,预售时间同步放出", excerpt: "老歌迷与新听众共同蹲守开票,票务平台热度飙升。", time: "今天 09:15", hot: 92 },
  { id: 3, image: "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20scene%20with%20bokeh%20lights%20and%20confetti%2C%20warm%20mint%20and%20cream%20palette%2C%20modern%20flat%20editorial%20illustration&width=640&height=440&seq=news-redcarpet&orientation=landscape", tag: "影坛新事", title: "电影节闭幕红毯,三套造型成全场焦点", excerpt: "造型师逐套解析设计巧思,睡前必看又添一条。", time: "昨天 23:40", hot: 85 },
  { id: 4, image: "https://readdy.ai/api/search-image?query=Bright%20variety%20show%20studio%20with%20round%20seats%20stage%20lights%20and%20gaming%20props%2C%20playful%20coral%20and%20mint%20color%20scheme%2C%20modern%20flat%20editorial%20illustration&width=640&height=440&seq=news-variety&orientation=landscape", tag: "综艺现场", title: "国民综艺回归,首期阵容藏悬念引期待", excerpt: "节目组公布概念海报,评论区已经在蹲更新喊话官微。", time: "昨天 20:05", hot: 95 },
];

export const faqs: Faq[] = [
  { q: "吃瓜每日是什么?它和普通娱乐资讯站有什么不同?", a: "吃瓜每日是一套把追瓜变成日常习惯的内容服务。我们不是简单堆资讯,而是帮你规划每天的通勤速览、午间刷新、蹲更新提醒与睡前必看时段,通过打卡与定时刷新,让你轻松持续跟住圈内动态。" },
  { q: "如何开始每日吃瓜打卡?", a: "每天打开页面点击顶部「立即打卡」即可记录一次。系统会按早、午、晚为你推荐不同批次内容,连续打卡可以沉淀专属的追瓜节奏,蹲更新更有章法。" },
  { q: "睡前必看和通勤速览有什么区别?", a: "通勤速览是早晨的浓缩瓜报,几分钟补齐隔夜内容;睡前必看则是晚间精选,把当天真正值得聊的几条梳理成清单,看完即可安心入睡,第二天不会掉队。" },
  { q: "蹲更新和定时刷新要手动设置吗?", a: "无需手动操作。你只需开启站内的更新提醒偏好,我们会按热点更新频率自动推送快讯;也可以自定义定时刷新提醒,重要瓜第一时间送达,不错过首更。" },
  { q: "内容会涉及个人隐私或不实信息吗?", a: "我们严格遵守资讯规范,优先采用官方与可核实信源,并对涉事个人隐私保持克制。涉及人物话题会标注信源与状态,发现偏差会第一时间更正,确保吃得安心。" },
  { q: "手机和平板都能用吗?需要下载 App 吗?", a: "完全响应式适配手机、平板与电脑,无需下载任何应用。收藏本页即可随时打卡、蹲更新,睡前刷一刷就能完成每日吃瓜任务。" },
];

export const testimonials = [
  { name: "阿圆", role: "通勤党", avatar: "https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20young%20woman%20with%20short%20hair%20and%20watermelon%20pattern%20background%2C%20warm%20mint%20tones&width=160&height=160&seq=avatar-a&orientation=squarish", text: "每天通勤五分钟扫一眼早安瓜报,再也不怕跟同事聊天接不上话。" },
  { name: "大顺", role: "综艺粉", avatar: "https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20young%20man%20wearing%20round%20glasses%20with%20coral%20melon%20background%2C%20friendly%20smile&width=160&height=160&seq=avatar-b&orientation=squarish", text: "蹲更新提醒太懂我了,新剧官宣从来不会让我错过首更。" },
  { name: "小葵", role: "睡前党", avatar: "https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20girl%20with%20long%20hair%20and%20yellow%20melon%20seed%20background%2C%20cheerful&width=160&height=160&seq=avatar-c&orientation=squarish", text: "睡前必看简直是救星,每天五分钟就能把重要瓜都吃明白,睡得也香。" },
];

export const stats = [
  { value: "128", suffix: "万+", label: "累计打卡" },
  { value: "36", suffix: "条/日", label: "精选更新" },
  { value: "24", suffix: "h", label: "蹲守陪跑" },
  { value: "9.2", suffix: "分", label: "平均瓜分" },
];